import {userRepository} from '@/repositories/Index';


class UserService {
    // 用户
    async getLoginUserFn() {
      const res = await userRepository.getLoginUser();
      return res;
    }

    // ebk登录提示邮箱配置信息
    async queryEbkLoginPromptMailboxFn() {
      const res = await userRepository.queryEbkLoginPromptMailbox();
      return res;
    }

     //换携程token
     async getSessionIdByTokenFn(params: any) {
      const res = await userRepository.getSessionIdByToken(params);
      return res;
    }
     
     //省市
     async areaFn() {
      const res = await userRepository.area();
      return res;
     }
  

    // 获取当前登录的酒店信息
    async  getCurrentHotelInfoFn() {
      const res = await userRepository.getCurrentHotelInfo();
      return res;
    }

    //发送短信验证码
    async  sendVerifyCodeFn(params: any) {
      const res = await userRepository.sendVerifyCode(params);
      return res;
    }

    //赫程登录
     async  generateLoginTokenFn(params: any) {
      const res = await userRepository.generateLoginToken(params);
      return res;
    }
    
       
  }
  
  export default UserService;
  